import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import ContentSlides from '../Components/ContentSlides';
import ImagesList from '../Components/ImagesList';
import ProductTitle from '../Components/ProductTitle';

function App() {
    const [product, setProduct] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { tipo, slug } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchProduct = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/produtos/${tipo}/${slug}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Produto não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar o produto.');
                }

                const data = await response.json();
                setProduct(data.produto);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchProduct();
    }, []);

    useEffect(() => {
        const updateViews = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/produtos/${product.tipo_slug}/${slug}/visualizar`, {
                    method: 'PUT',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Erro ao atualizar progresso.');
                }
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            }
        };

        let timeout;
        if (product) {
            timeout = setTimeout(() => {
                updateViews();
            }, 5000);
        }

        return () => clearTimeout(timeout);
    }, [product]);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle productName={product.nome} loading={loading} back={`/painel/produtos/${product.tipo_slug}`} />
                        {loading && (
                            <>
                                <ContentSlides loading={loading} />
                                <ContentSlides loading={loading} />
                            </>
                        )}
                        {product.grupos &&
                            product.grupos.map((grupo) => {
                                if (grupo.tipo === 'imagem' && grupo.imagens && grupo.imagens.length > 0) {
                                    return (
                                        <ImagesList
                                            key={`grupo-imagem-${grupo.id}`}
                                            content={grupo.imagens}
                                            isCarousel={true}
                                            url={`/painel/produtos/${product.tipo_slug}/${product.slug}/imagens/${grupo.slug}`}
                                            title={grupo.nome}
                                            loading={loading}
                                            seeAll={true}
                                        />
                                    );
                                } else if (grupo.tipo === 'video' && grupo.videos && grupo.videos.length > 0) {
                                    return (
                                        <ContentSlides
                                            key={`grupo-video-${grupo.id}`}
                                            content={grupo.videos}
                                            isCarousel={true}
                                            url={`/painel/produtos/${product.tipo_slug}/${product.slug}/videos/${grupo.slug}/`}
                                            title={grupo.nome}
                                            loading={loading}
                                            seeAll={true}
                                        />
                                    );
                                } else if (grupo.tipo === 'material' && grupo.materiais && grupo.materiais.length > 0) {
                                    return (
                                        <ContentSlides
                                            key={`grupo-material-${grupo.id}`}
                                            content={grupo.materiais}
                                            isCarousel={true}
                                            url={`/painel/produtos/${product.tipo_slug}/${product.slug}/materiais/${grupo.slug}/`}
                                            title={grupo.nome}
                                            loading={loading}
                                            seeAll={true}
                                        />
                                    );
                                }
                                return null;
                            })}
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
